let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("c6MKV"), load("aZinD"), load("joJy8"), load("aHE9G"), load("9FFAj")]).then(() => parcelRequire('jW3wg'));